/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PeriodYear/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function PeriodYear({
  children,
  viewPath = "/DesignSystem/ReportsKpiFilters/PeriodYear",
  onChange
  
}) {
let tabSelectedFiltersPeriodYearsValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.filters.period_years',
})
let tabSelectedFiltersPeriodYearIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.filters.period_year_id',
})
let tabSelectedFiltersPeriodYearIdChangeData = fromData.useDataChange({ viewPath,
context: 'tab',
path: 'selected.filters.period_year_id',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 data="tab.selected.filters.period_years"
 from={tabSelectedFiltersPeriodYearsValueData}
 data="tab.selected.filters.period_year_id"
 onChange={tabSelectedFiltersPeriodYearIdChangeData}
 value={tabSelectedFiltersPeriodYearIdValueData}
 maxWidth={80}
 flexGrow={0}
 marginLeft={dtSpaceXxs}
 size="small"
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Year"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}